import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationScatterplotIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "rect",
    {
      x: "64",
      y: "888",
      width: "896",
      height: "72",
      rx: "32",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M277.292 659.905C277.292 598.537 327.041 548.787 388.41 548.787C449.778 548.787 499.528 598.537 499.528 659.905C499.528 721.274 449.778 771.024 388.41 771.024C327.041 771.024 277.292 721.274 277.292 659.905Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M80 400.252C80 358.922 113.505 325.417 154.835 325.417C196.165 325.417 229.669 358.922 229.669 400.252C229.669 441.582 196.165 475.087 154.835 475.087C113.505 475.087 80 441.582 80 400.252Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M665.004 164.456C724.844 187.075 770.901 237.757 787.122 300.446C813.918 284.13 831.811 254.643 831.811 220.976C831.811 169.627 790.184 128 738.835 128C708.747 128 681.998 142.291 665.004 164.456Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M851.023 383.307C851.023 357.632 871.837 336.819 897.512 336.819C923.186 336.819 944 357.632 944 383.307C944 408.982 923.186 429.795 897.512 429.795C871.837 429.795 851.023 408.982 851.023 383.307Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M428.094 350.362C428.094 258.309 502.718 183.685 594.772 183.685C686.825 183.685 761.449 258.309 761.449 350.362C761.449 442.415 686.825 517.039 594.772 517.039C502.718 517.039 428.094 442.415 428.094 350.362Z",
      fill: "#0A3A83"
    }
  )
] });
export {
  VisualisationScatterplotIcon
};
